import type { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"
import { notifyError, notifySuccess } from "@lib/helper"
import { L, LNotification } from "@lib/abpUtility"
import {
  RowCompanyModel,
  CompanyDetailModel,
} from "@models/clientManagement/companyModel"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class CompanyService {
  public async createOrUpdate(body: any) {
    const result = await http.post(
      "api/services/app/Company/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async delete(id: number) {
    const result = await http.delete("api/services/app/Residents/Delete", {
      params: { id },
    })
    return result.data
  }

  public async activate(id: number, isActive) {
    const result = await http.post(
      "api/services/app/Company/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return result.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("Error"), L("EntityNotFound"))
    }

    const res = await http.get(`api/services/app/Company/Get?id=${id}`)
    const { result } = res.data

    return CompanyDetailModel.assign(result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Company/GetAll", { params })
    const { result } = res.data
    result.items = RowCompanyModel.assigns(result.items)
    return result
  }

  public async exportExcel(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportCompany", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-COMPANY-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }

  public async impportCompanys(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)

    const result = await http.post("api/Imports/ImportCompany", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })

    return result.data.result
  }
}

export default new CompanyService()
